import { render, staticRenderFns } from "./header.container.vue?vue&type=template&id=e0419f52&"
import script from "./header.container.ts?vue&type=script&lang=ts&"
export * from "./header.container.ts?vue&type=script&lang=ts&"
import style0 from "./header.container.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\admin\\Documents\\baocaodieuhanh\\source\\vnta-qltp-frontend\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0419f52')) {
      api.createRecord('e0419f52', component.options)
    } else {
      api.reload('e0419f52', component.options)
    }
    module.hot.accept("./header.container.vue?vue&type=template&id=e0419f52&", function () {
      api.rerender('e0419f52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/presentation/containers/header/header.container.vue"
export default component.exports